import { Box, useTheme, IconButton, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { tokens } from "../../../../../theme";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShCopyButton from '../../../../../components/theme/ShCopy';
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useBulkDeleteImportOrdersMutation, useDeleteImportOrderMutation, useGetImportOrdersQuery, useSyncImportOrderMutation } from "../../../../../newapi/order/importOrderSlice";
import { getImportOrderStateData } from "../../../../../utils/labelColorText";
import { general_states } from '../../../../../utils/staticEnums';
import SyncIcon from '@mui/icons-material/Sync';
import DeleteIcon from '@mui/icons-material/Delete';
import DataObjectIcon from '@mui/icons-material/DataObject';
import { useSelector } from "react-redux";
import { selectUser } from "../../../../../newapi/user/authentication/authSlice";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { ORDER_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';
import Text from "../../../../../components/theme/text/Text";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import { SwapHorizOutlined } from '@mui/icons-material';
import { showToastMessageDeleteRequest, showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import SHQuickAction from '../../../../../components/theme/Modal/SHQuickAction';
import MDynamicValues from "../../../../../components/global/Modals/MDynamicValues";

import cx from 'classnames';
import MConfirmation from "../../../../../components/global/Modals/MConfirmation";
import MOrderWebshopJson from "../../../../../components/global/Modals/MOrderWebshopJson";
import ShDataGridSelectedActions from "../../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import DropdownButton from "../../../../../components/theme/buttons/DropdownButton";
const SpOrderDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails"));


const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const colors = tokens(theme.palette.mode);


    return (
        <Box

            sx={{
                display:"flex",
                gap:2,

                "@media screen and (max-width: 47.9375em)" : {
                    // mr:"-24px",
                    width:1,
                }
            }}
        >
            {["bol", "shopify", "woocommerce"].includes(props.webshopType) && (
                <Shbutton
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained"
                    onClick={props.onFetchOrder}
                    startIcon={<DownloadOutlinedIcon />}
                >
                    {t("fetch_order")}
                </Shbutton>
            )}

            <ToggleButtonGroup
                color={props.showInactive ? "green" : "red"}
                value={props.showInactive}
                exclusive
                onChange={() => {
                    if(props.showInactive === false) {
                        props.setConfig(true)
                    } else {
                        props.setConfig(false)
                    }
                }}
                aria-label="Active"

                className={cx(`${props.showInactive}`, {
                    'active': props.showInactive
                })}
                sx={{

                    background:colors.red[100],
                    padding:0.5,
                    borderRadius:5,
                    transition:"250ms",
                    "&.active" : {
                        background: colors.grey[100],
                        transition:"250ms",
                    },
                    "@media screen and (max-width: 47.9375em)" : {
                        display:"none",
                    }
                }}
            >
                <ToggleButton
                    sx={{
                        padding: 0,
                        paddingX: 2,
                        border: 0,
                        lineHeight: "32px",
                        textTransform: "unset",
                        borderRadius: "32px !important",
                        color:props.showInactive  ?"#fff": colors.red[400],  // White text
                        background: props.showInactive  ? colors.grey[400] : "transparent", // Red background if inactive
                        transition: "250ms",
                        "&.Mui-selected": {
                            background: colors.grey[400],
                            color: "#fff",
                            fontWeight:"bold",
                        },
                        "&.Mui-selected:hover": {
                            background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                        },
                    }}
                    value={true}
                >
                    {t('all')}
                </ToggleButton>
                <ToggleButton
                    sx={{
                        padding: 0,
                        paddingX: 2,
                        border: 0,
                        lineHeight: "32px",
                        textTransform: "unset",
                        borderRadius: "32px !important",
                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], // White text
                        background: !props.showInactive ? colors.red[400] : "transparent", // Green background if active
                        transition: "250ms",
                        "&.Mui-selected": {
                            background: colors.red[400], // Green background if selected
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] :  colors.txt["white"], // White text
                            fontWeight:"bold",
                        },
                        "&.Mui-selected:hover": {
                            background:theme.palette.mode === "dark" ? "#FCADAC" : "#C2002C"
                        },
                    }}
                    value={false}
                >
                    {t('only_failed')}
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

let gridOptions = {
    export: true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};

const WebshopCredentialsOrderLogs = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [data, setData] = useState([]);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    const [showAll, setShowAll] = useState(false);
    const user = useSelector(selectUser);
    const [webshopJsonImportOrder, setWebshopJsonImportOrder] = useState(null);
    const [config, setConfig] = useState({
        webshopCredentialsId: props.webshopCredentialsId,
        state: general_states.FAILED,
    });

    const ref = useRef();

    // Update config when webshopCredentialsId prop changes
    useEffect(() => {
        setConfig((config) => ({
            ...config,
            webshopCredentialsId: props.webshopCredentialsId
        }));
        // Clear data when switching webshop credentials to prevent old data from showing
        setData([]);
    }, [props.webshopCredentialsId]);

    useEffect(() => {
        setConfig((config) => {
            if (showAll) {
                return {
                    ...config,
                    state: false,
                };
            } else {
                return {
                    ...config,
                    state: general_states.FAILED,
                };
            }
        });
    }, [showAll]);
    
    const [selectedItems, setSelectedItems] = useState([]);
    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    }
        
    const [bulkDeleteImportOrders, {isLoading: isBulkLoading}] = useBulkDeleteImportOrdersMutation();
    const handleConfirmBulkDelete = async () => {
        try {
            if (isBulkLoading) return;

            const response = await bulkDeleteImportOrders({orderIds: selectedItems}).unwrap();
            showToastMessageDeleteRequest(t, response);
        } catch (err) {
            showToastMessageRequestError(t('delete_failed'),t, err);
        }
    }
        
    const [open, setOpen] = useState(false);
    const confirmModal = {
        open: open,
        setOpen: setOpen,
        confirm: handleConfirmBulkDelete
    } 

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions showInactive={showAll} setConfig={setShowAll} webshopType={props.webshopType} onFetchOrder={() => setFetchOrderModalOpen(true)}></GridActions>,
            topRight: 
                <ToggleButtonGroup
                    color={showAll ? "green" : "red"}
                    value={showAll}
                    exclusive
                    onChange={() => {
                        if(showAll === false) {
                            setShowAll(true);
                            // setConfig(config => ({
                            //     ...config,
                            //     showInactive:true,
                            // }))
                        } else {
                            setShowAll(false);
                            // setConfig((config) => ({
                            //     ...config,
                            //     showInactive: false,
                            // }))
                        }
                    }}
                    aria-label="Active"

                    className={cx(`${showAll}`, {
                        'active': showAll
                    })}
                    sx={{

                        background:colors.red[100],
                        padding:0.5,
                        borderRadius:5,
                        transition:"250ms",
                        borderTopRightRadius:0,
                        borderBottomRightRadius:0,
                        pr:0,
                        py:0,
                        "&.active" : {
                            background: colors.grey[200],
                            transition:"250ms",
                        },
                    }}
                >
                    <ToggleButton
                        sx={{
                            padding: 0,
                            paddingX: 2,
                            border: 0,
                            lineHeight: "32px",
                            textTransform: "unset",
                            borderRadius: "32px !important",
                            color:showAll  ?"#fff": colors.red[400],  // White text
                            background: showAll ? colors.grey[400] : "transparent", // Red background if inactive
                            transition: "250ms",
                            "&.Mui-selected": {
                                background: colors.grey[400], 
                                color: "#fff", 
                                fontWeight:"bold",
                            },
                            "&.Mui-selected:hover": {
                                background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                            },
                        }}
                        value={true}
                    >
                        {t('all')}
                    </ToggleButton>
                    <ToggleButton
                        sx={{
                            padding: 0,
                            paddingX: 2,
                            border: 0,
                            lineHeight: "32px",
                            textTransform: "unset",
                            borderRadius: "32px !important",
                            color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], // White text
                            background: !showAll ? colors.red[400] : "transparent", // Green background if active
                            transition: "250ms",
                            borderTopRightRadius:"0px !important",
                            borderBottomRightRadius:"0px !important",
                            "&.Mui-selected": {
                                background: colors.red[400], // Green background if selected
                                color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] :  colors.txt["white"], // White text
                                fontWeight:"bold",
                            },
                            "&.Mui-selected:hover": {
                                background:theme.palette.mode === "dark" ? "#FCADAC" : "#C2002C"
                            },
                        }}
                        value={false}
                    >
                        {t('only_failed')}
                    </ToggleButton>
                </ToggleButtonGroup>
                
        });

        return () => {

        }
    }, [config,showAll,props.webshopType]);


    const [syncOrder, {isLoading}] = useSyncImportOrderMutation();
    const handleSyncOrder = async(row) => {
        try {
            if (isLoading) return;
            const response = await syncOrder(row).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (error) {
            showToastMessageRequestError(t('update_failed'), t, error);
        }
    }

    const [deleteLog, {isLoading: isDeleteLoadng}] = useDeleteImportOrderMutation();
    const handleDeleteLog = async() => {
        try {
            if (isDeleteLoadng) return;
            const response = await deleteLog({id: selectedLog}).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (error) {
            showToastMessageRequestError(t('update_failed'), t, error);
        }
    }

    const [selectedLog, setSelectedLog] = useState(0);
    const openDeleteModal = (row) => {
        setSelectedLog(row.id);
        confirmDeleteModal.setOpen(true);
    }

    const [confirmDeleteModalOpen, setConfirmDeleteModalOpen] = useState(false);
    const confirmDeleteModal = {
        open: confirmDeleteModalOpen,
        setOpen: setConfirmDeleteModalOpen,
        confirm: handleDeleteLog
    };

    const [fetchOrderModalOpen, setFetchOrderModalOpen] = useState(false);
    const handleFetchOrderConfirm = (formValues) => {
        handleSyncOrder({
            id: 0,
            credentialsId: props.webshopCredentialsId,
            externalId: formValues.webshopreference
        });
    };

    const [orderId, setOrderId] = useState();
    const orderIdRef = useRef(orderId);
    
    const getOrderDetails = (id) => {
        if (!id) return;
    
        const neworderId = parseInt(id);
        // Only update state if the orderId has actually changed
        if (orderIdRef.current !== neworderId) {
            if (!spLoading) {
                setSpLoading(true);
            }
            setOrderId(neworderId);
            orderIdRef.current = neworderId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {
            field: "webshopreference",
            headerName: t('webshopreference'),
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Box sx={{
                        minWidth: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                        whiteSpace: "nowrap",
                        wordBreak: "keep-all",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        ".copyel": {
                            opacity: 0,
                        },
                        "&:hover .copyel": {
                            opacity: 1,
                        }
                    }}>
                        <Text noBreak>{params.row.webshopreference}</Text>
                        <ShCopyButton 
                            styles={{button: {
                                background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover": {
                                    background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[300],
                                }
                            }}} 
                            sx={{position: "absolute", right: 0, zIndex: 3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.webshopreference}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {
            field: "order", 
            headerName: t("order"), 
            flex: 1, 
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if (!params.row.order) {
                    return <></>;
                }

                return <Box onClick={() => getOrderDetails(params.row.order.id)}
                sx={{
                    width:1,
                    height:"100%",
                    display:"flex",
                    alignItems:"center",
                    ".copyel": {
                        opacity:0,
                    },
                    "&:hover .copyel": {
                        opacity:1,
                    }
                }}>
                    <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.order.barcode}</Text>
                </Box>
            }
        },
        {
            field: "orderPlacedDateTime", 
            headerName: t("created_at"), 
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (!params.row.orderPlacedDateTime) {
                    return <></>;
                }
                
                return new Date(params.row.orderPlacedDateTime).toLocaleString(i18n.language, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                });
            }
        },
        {
            field: "updatedAt", 
            headerName: t("updated_at"), 
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                
                return new Date(params.row.updatedAt).toLocaleString(i18n.language, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                });
            }
        },
        {
            field: "message", 
            headerName: t("remark"), 
            flex: 2,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                if (params.row.errorMessage && params.row.errorMessage.length > 0) {
                    return (
                        <Box sx={{display: "flex", alignItems: "center"}}>
                                    <ShCopyButton 
                                        styles={{button: {
                                            background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[200],
                                            color: colors.txt["primary"],
                                            "&:hover": {
                                                background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[300],
                                            },
                                            marginRight: 1
                                        }}} 
                                        className={"copyel"} 
                                        closeAfter={1500} 
                                        value={params.row.errorMessage}
                                    ></ShCopyButton>
                        <SHQuickAction
                            component={
                                <Box
                                    sx={{
                                        px:1.5,
                                        display:"flex",
                                        flexDirection:"column"
                                    }}
                                >
                                    <Text>
                                        {params.row.errorMessage}
                                    </Text>
                                </Box>
                            }
                        >
                            {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                <Box
                                    aria-owns={anchorEl ? 'simple-popover' : undefined}
                                    aria-haspopup={false}
                                    onMouseEnter={params.row.latestHandoverDateTime !== null ? onMouseEnter : null}
                                    onMouseLeave={params.row.latestHandoverDateTime !== null ? onMouseLeave : null}
                                    onTouchStart={params.row.latestHandoverDateTime !== null ? onTouchStart : null}
                                    sx={{
                                        width:1,
                                    }}
                                >
                                    <Text>{params.row.errorMessage}</Text>
                                </Box>
                            )}
                        </SHQuickAction>
                        </Box>
                    );
                } else {
                    return params.row.message;
                }
            }
        },
        {
            field: "state", 
            headerName: t("state"), 
            flex: 1,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                const stateData = getImportOrderStateData(params.row.state, theme);
                return (
                    <ShLabel variant={stateData.labelcolor}  palette="normal">
                        {t(stateData.labeltext)}
                    </ShLabel>
                );
            }
        },
        {
            field: "actions", 
            headerName: "",
            flex:0.5,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                if (![general_states.FAILED, general_states.IGNORED].includes(params.row.state)) {
                    return <></>;
                }

                return <Box sx={{
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"flex-end",
                }}>
                    <IconButton type="button" onClick={() => handleSyncOrder({id: params.row.id})}
                    sx={{ 
                        color: colors.txt["primary"]
                    }}>
                        <SyncIcon/>
                    </IconButton>
                    {user?.sha && !params.row.webshopCredentials?.integratorId && params.row.webshopCredentials?.webshop_type !== "api" &&
                        <IconButton type="button" onClick={() => setWebshopJsonImportOrder(params.row)}
                        sx={{ 
                            color: colors.txt["primary"]
                        }}>
                            <DataObjectIcon/>
                        </IconButton>
                    }
                    <IconButton type="button" onClick={() => openDeleteModal(params.row)}
                    sx={{ 
                        color: colors.red[400]
                    }}>
                        <DeleteIcon/>
                    </IconButton>
            </Box>
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <Box>
                        {/* Mobile card view would go here */}
                    </Box>
                )
            }
        }
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2
                key={`${theme.palette.mode}-${config.webshopCredentialsId}-${config.state}`}
                content={useGetImportOrdersQuery}
                gridActions={<GridActions showInactive={showAll} setConfig={setShowAll} webshopType={props.webshopType} onFetchOrder={() => setFetchOrderModalOpen(true)}/>}
                config={config}
                title={t('orders')}
                gridOptions={gridOptions}
                columns={columns}
                rows={data}
                sortModel={{field: columns[2].field, type: "DESC"}}
                selectable={true}
                setSelected={onSelected}
                selectedItems={selectedItems}
                selectedActions={
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        <DropdownButton onClick={() => confirmModal.setOpen(true)} icon={<DeleteIcon/>} text={t("delete")}/>
                    </ShDataGridSelectedActions>
                }
                isRowSelectable={(row) => {
                    return row.state === general_states.FAILED;
                }}
            >
            </ShDataGrid2>
            <MConfirmation
                open={confirmDeleteModal.open}
                handleClose={() => confirmDeleteModal.setOpen(false)}
                title={t("delete_order_log_title")}
                subtitle={t("delete_order_log_subtitle")}
                confirm={confirmDeleteModal.confirm}
            />
            <MConfirmation
                open={confirmModal.open}
                handleClose={() => confirmModal.setOpen(false)}
                title={t("delete_all_import_logs")}
                content={t("are_you_sure")}
                confirm={confirmModal.confirm}
            />

            <MDynamicValues
                open={fetchOrderModalOpen}
                handleClose={() => setFetchOrderModalOpen(false)}
                title="fetch_order"
                fields={[
                    {
                        name: "webshopreference",
                        label: "webshopreference",
                        type: "text",
                        required: true,
                        defaultValue: ""
                    }
                ]}
                onConfirm={handleFetchOrderConfirm}
            />

            <MOrderWebshopJson
                open={!!webshopJsonImportOrder}
                handleClose={() => setWebshopJsonImportOrder(null)}
                importOrder={webshopJsonImportOrder}
            />

            {spLoading &&
                <SpOrderDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    orderId={orderId}
                />
            }
        </Box>
    );
}

export default WebshopCredentialsOrderLogs; 